// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".iconWrapper--1czB3WXt {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.iconControl--2o8XyJzN {\n  opacity: 0;\n}\n\n.iconControl--2o8XyJzN:hover {\n  opacity: 1;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconWrapper": "iconWrapper--1czB3WXt",
	"iconControl": "iconControl--2o8XyJzN"
};
export default ___CSS_LOADER_EXPORT___;
